"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerBody = void 0;
const react_bootstrap_1 = require("react-bootstrap");
const styled_components_1 = __importDefault(require("styled-components"));
exports.ContainerBody = (0, styled_components_1.default)(react_bootstrap_1.Container) `
  padding: 0 5%;
  width: 100%;
  margin-top: 117px;
  min-height: 100vh;
  height: auto;
  &.closedContainer {
    padding: 0 5% 0 1%;
  }
  .transitionCol {
    transition: 0.3s;
  }
  @media screen and (max-width: 1600px) {
    padding: 0 2%;
  }
`;
